import { InvoiceStatusType, InvoiceTransitionDto, InvoiceType } from 'types/invoices';
import { wasEverInStatus } from './invoiceStepTransition';

const { DRAFT, REVIEWED, APPROVED, FINALIZED, SENT, PAID, POSTPONED, CREDITED } = InvoiceStatusType;

const DEBIT_STAGES: InvoiceStatusType[] = [DRAFT, REVIEWED, APPROVED, FINALIZED, SENT, PAID];
const CREDIT_STAGES: InvoiceStatusType[] = [DRAFT, FINALIZED, SENT];
const CORRECTION_STAGES: InvoiceStatusType[] = [DRAFT, FINALIZED, SENT, PAID];
const POSTPONED_STAGES: InvoiceStatusType[] = [DRAFT, REVIEWED, POSTPONED];

/**
 * The statuses an invoice moves through, in order: a debit's or a prepayment's six, a credit note's three, a
 * correction's four; a postponed invoice ends at Postponed, and a credited one adds Credited.
 */
export const getInvoiceStageStatuses = (invoiceTypeCode: string, statusCode: string): InvoiceStatusType[] => {
    const isCredited = statusCode === CREDITED;
    if (invoiceTypeCode === InvoiceType.CREDIT) return CREDIT_STAGES;
    if (invoiceTypeCode === InvoiceType.CORRECTION) {
        return isCredited ? [...CORRECTION_STAGES, CREDITED] : CORRECTION_STAGES;
    }
    if (statusCode === POSTPONED) return POSTPONED_STAGES;
    return isCredited ? [...DEBIT_STAGES, CREDITED] : DEBIT_STAGES;
};

/**
 * Where the invoice stands against a stage. A stage before the current one that the invoice never entered was
 * skipped (Draft never is); of those after it, only the first is `next`, the one whose people the stepper names.
 */
export type InvoiceStageState = 'done' | 'skipped' | 'current' | 'paused' | 'next' | 'ahead';

export const getInvoiceStageState = (
    stages: InvoiceStatusType[],
    index: number,
    statusCode: string,
    transitions: InvoiceTransitionDto[] | undefined
): InvoiceStageState => {
    const current = stages.indexOf(statusCode as InvoiceStatusType);
    const status = stages[index];
    if (index === current) return status === POSTPONED ? 'paused' : 'current';
    if (index < current) return status !== DRAFT && !wasEverInStatus(transitions, status) ? 'skipped' : 'done';
    return index === current + 1 ? 'next' : 'ahead';
};
